module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.0.0.box.589.199.1025.102.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.14.0.0.box.589.199.1025.102.q.100"
    }
  }, [_vm._v("Basic Crab Information")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.402.482.1400.1955.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.0.box.402.482.1400.221.q.60"
    }
  }, [_vm._v("Welcome to the beautiful Chesapeake Bay, the Land of Pleasant Living, and its prized catch, the blue crab "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(Callinectes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sapidus, ")]), _vm._v("meaning savory beautiful swimmer), a crustacean (along with lobsters and shrimp). One could say the Bay area is crab-u-lous.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.402.699.1400.600.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  }), _vm._v("The Bay is the largest estuary in the United States (there are 840 other estuaries in the country), measuring about two hundred miles north to south and between almost three miles wide at its northern end to thirty miles wide where the Potomac River feeds into the Bay on its way to meet the Atlantic Ocean. It drains 150 rivers and streams from Delaware, Maryland, New York, Pennsylvania, Virginia, West Virginia, and Washington, D.C., creating a basin of more than 64,000 square miles. The largest rivers flowing into the Bay are the Susquehanna, Patapsco, Chester, Choptank, Patuxent, Nanticoke, Potomac, and Pocomoke feeding in from Maryland and the Rappahannock, York, and James rivers feeding in from Virginia.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.2.box.402.1295.1399.112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.2.0"
    }
  }), _vm._v("The bay yields more fish and shellfish (about 45,000 short tons) than any other estuary in the United States.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.3.box.402.1403.1400.384.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.3.0"
    }
  }), _vm._v("Early Maryland settlers lived within close proximity of the Bay, more as a transportation route than because of the food source contained within its waters. The settlers worked the land as their primary nourishment supply. It was plentiful, inexpensive, and nutrient-rich. Anyone fishing in the Bay’s waters was as likely to be doing so for a recreational as for commercial purpose. The equipment available for catching fish was pretty much limited to hook and line and raking the shore for oysters.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.4.box.402.1782.1400.438.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.4.0"
    }
  }), _vm._v("With a rapidly increasing population, hurricanes, weather changes, and various wars and skirmishes, fishing (and crabbing) was not looked upon as a reliable food supply or a steady income. On the other hand, with the development of rail shipping and refrigerated transportation, the ability to move Bay products beyond its shorelines started increasing. The availability of canning equipment beginning in the late 1870s also increased the ability to transport crabmeat to places beyond the local communities.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.5.box.402.2216.1400.221.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.5.0"
    }
  }), _vm._v("Virginia’s watermen have been catching blue crabs and eighty-six other varieties of seafood since the first settlement in Jamestown. Today, the state is the nation’s fourth largest seafood producer and the largest on the East Coast.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.0.0.box.602.214.1400.2225.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.0.box.602.214.1400.383.q.60"
    }
  }, [_vm._v("Capt. John Smith (1580-1631) is credited as being the first European to explore the Bay, in 1607 and 1608, during his voyages through the waterway seeking a Northwest Passage to the western states. Fortunately, he made meticulous notes and his maps of the Bay, published in 1612, served as the most important point of information for Bay settlers. They have also been instrumental historically for those who are working to restore the Bay to a more viable condition.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.1.box.602.593.1400.317.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.1.0"
    }
  }), _vm._v("The Captain John Smith Chesapeake National Historic Trail, tracing 3,000 miles of historic voyages by Smith, is the first national water trail in the country. Through the trail, you can learn about the importance of and dangers to the Bay, the maritime history, the English settlement of this part of the country, and the traditions of the Native Americans who lived here.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.2.box.602.918.1400.221.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.2.0"
    }
  }), _vm._v("Friends of the John Smith Chesapeake Trail, the Chesapeake Bay Foundation, Sultana Projects, Inc., National Oceanic & Atmospheric Administration, Verizon Wireless, National Geographic Society, and the Conservation Fund have been working together on this trail project.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.3.box.602.1135.1400.329.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.3.0"
    }
  }), _vm._v("Sultana’s John Smith 400 Project built a replica of Smith’s twentyeight-foot shallop (a type of boat) that was crewed by twelve modern explorers, naturalists, educators, and historians who duplicated Smith’s travels on 1,500 miles of water under sail and oar power in the summer of 2007. The 121-day trip stopped at more than twenty ports along the way, taking the voyage to the public.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.4.box.602.1460.1400.479.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.4.0"
    }
  }), _vm._v("Even without a boat, you can follow his travels through the Captain John Smith Chesapeake National Historic Water Trail. The Chesapeake Bay Interpretive Buoy System (CBIBS) allows you to explore his voyages vicariously through the Internet. Each buoy marked on the map has an audio presentation about the history, geography, and a seasonal report. The buoys are located at Susquehanna, Patapsco, Annapolis (Severn River), upper and lower Potomac River, Gooses Reef, Stingray Point, James River at Jamestown, and Elizabeth River at Norfolk.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.5.box.602.2001.1400.438.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.5.0"
    }
  }), _vm._v("In 1917 Maryland implemented its first measures against the harvest of sponge crabs and Virginia followed suit in the next decade. Virginia lifted the ban in 1932, and while the market lessened during the Great Depression and Prohibition, the development of the crab pot in the mid-1930s started it back upwards again. Although the demand for crabmeat lessened during World War II, it was not a rationed food so it was fairly readily available. The industry benefited in postwar days because of the new products and equipment developed during the war.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.0.0.box.402.214.1400.1629.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.0.box.402.214.1400.383.q.60"
    }
  }, [_vm._v("Blue crabs are vital to the Bay because they provide a food source for humans and other Bay inhabitants (other crabs, striped bass, catfish, and other species dine on crabs—particularly soft-shelled and juveniles), employment (catching them; cooking, picking, packing, and shipping crabmeat; preparing crab for consumption, etc.), and are a predator that feeds on bivalves, fish, plants, and other organisms that filter down to the bottom of the Bay where they live.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.1.box.402.593.1400.654.q.60"
    }
  }, [_vm._v("Although the blue crab of the Chesapeake has a limited season (April 1 through December 15), it’s estimated that the Bay provides one-third of the crabs consumed in this country. Other blue crabs and similar relatives come from the Gulf of Mexico and Asian waters. The crab is among an estimated three hundred species of fish and shellfish, with the striped bass (rockfish) being the state fish. It had been fished nearly to extinction until a moratorium was enacted so the population could increase. The catch is still strictly limited and fishermen are regularly charged with violating the number, size, and weight limits. Commercially caught and sold striped bass must be checked in to verify where and how each fish was caught and must have colored tags indicating where they were caught.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.2.box.402.1243.1400.383.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.2.0"
    }
  }), _vm._v("Starting in 2008, Maryland and Virginia joined forces to impose strict limits on the number of female crabs that could be caught. The aim of the program is to increase the crab population so that the life and business of the commercial crabbers could continue to be worthwhile and profitable, and to assure the availability of crabs for leisure crabbers and diners around the Bay and the world. They also prohibited the issuance of new commercial licenses.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.0.3.box.402.1622.1400.221.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.3.0"
    }
  }), _vm._v("Egg-bearing females (sooks or spongys) that have mated with Jimmies during the summe"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  }), _vm._v("r start migrating to the warmer waters of the southern Bay in mid-September. Althoug"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.0.0"
    }
  }), _vm._v("h the outcome has been spectacular and one might think it beneficial to maintain the ban for"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.0.0.box.602.214.1400.112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _vm._v("\nat least another year or two, the crabbers keep asking to be allowed a larger catch.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.16.1.0.box.401.1893.1406.542.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0008.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.0.0.box.602.214.1400.1521.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.1.box.602.322.1400.221.q.60"
    }
  }, [_vm._v("The results, says the Chesapeake Bay Program, indicate a 70 percent increase in adult crabs, the first major jump since 1993; however, the number of juveniles is still below the desired numbers to sustain this industry.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.2.box.602.539.1400.275.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.2.0"
    }
  }), _vm._v("According to Virginia governor Bob McDonnell and Maryland governor Martin O’Malley, the blue crab population has increased the last two years because of this stock-rebuilding program. The 2010 survey estimated the population had increased by 60 percent, to 658 million crabs (give or take a dozen or two), the largest number since 1997.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.3.box.602.810.1400.275.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.3.0"
    }
  }), _vm._v("This in no way indicates the Bay is as healthy as it should or could be, but it is a sign of improvement. Fertilizers and other chemicals used in farming are a major source of pollution. Run-off from acres and acres of parking lots, highways and streets, commercial properties, and housing developments is another major source.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.4.box.602.1081.1400.600.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.4.0"
    }
  }), _vm._v("One slightly unusual cause of pollution is referred to as derelict crab traps. These are traps that have come loose from crab lines laid by commercial crabbers. They are considered an eye sore, a navigational hazard, and a danger to other species that become caught accidentally in the traps. They are considered derelict or ghost traps, and they keep company with fishing gear, beverage bottles and cans, items that fall off boats and piers, and other marine debris that manage to break away from where it belongs. No one is saying crabbers deliberately drop the traps, for they cost about $20.00 to $30.00 each. Quite often it’s pleasure boats that sail or motor by that sever the lines and cause the traps to sink.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.5.box.652.1676.1350.59.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  }), _vm._v("The concern is about "), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.0.0"
    }
  }), _vm._v("“any manmade solid material that is—"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.0.0.box.402.214.1400.383.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _vm._v("\ndirectly or indirectly, intentionally or unintentionally—disposed of or abandoned into the marine environment. It may end up in the water or on the shoreline from people on boats or along the shoreline, or can be washed out to sea via rivers, streams, and storm drains. Because marine debris can hurt the ecosystem, NOAA (National Oceanographic and Atmospheric Administration) is researching what those impacts are—and how to mitigate those negative effects.”")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.1.0"
    }
  }), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.17.1.0.box.601.1775.1401.662.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0009.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.0.0.box.402.214.1400.2225.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.1.box.402.593.1399.263.q.60"
    }
  }, [_vm._v("The NOAA Chesapeake Bay office studied the effects of this gear on the habitat to determine the “safety, nuisance, environmental, and economic impacts in coastal waters,” noting that the Bay’s “crab fishery—the nation’s largest—uses metal traps as the primary method of harvest.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.2.box.402.864.1400.600.q.60"
    }
  }, [_vm._v("An estimated “300,000 crab traps are deployed each summer day and from that number commercial fishermen may lose from 20 to 30 percent of their traps for a variety of reasons.” Although each trap is attached to a marker buoy that identifies its owner and helps with retrieval, the traps become detached when a vessel’s propeller cuts a line or wave action and current otherwise sever it. The traps can’t be located or retrieved and any catch can’t be harvested. These traps may trap, wound, and eventually kill “crabs, fish, birds, reptiles, and aquatic mammals; degrading marine ecosystems and sensitive habitats . . . and forming hazards to recreational, commercial, and military navigation.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.3.box.402.1460.1400.383.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.3.0"
    }
  }), _vm._v("The ghost traps, although empty of set bait, can attract crabs, fish, and terrapins, which then cannot escape; they die and become bait that attracts other sea life and the cycle continues. Recreational fishers are also concerned because this cycle has an impact on their catch. One estimate noted that each pot or trap could attract about four dozen crabs or nearly a bushel, and when that’s multiplied times 17,000 or more traps, a lot of the potential crab catch is lost.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.4.box.402.1839.1400.329.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.4.0"
    }
  }), _vm._v("The NOAA Chesapeake Bay Office, the Maryland Department of Natural Resources, Virginia Marine Resources Commission, Virginia Institute of Marine Science, and the NOAA Marine Debris Program surveyed the Bay from late February through late March 2007 (harvesting was closed to commercial fishery, which assured that any traps located were derelict).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.5.box.402.2164.1400.275.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.5.0"
    }
  }), _vm._v("These studies indicated about 85,000 crab traps were on the bottom of the Maryland portion of the Bay and another 35,000 in the Virginia portion of the Bay and its tributaries. One option for future elimination or prevention of this problem is to include “biodegradable components into crab trap design and construction.”")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.0.0.box.602.214.1400.1304.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.0.0.box.602.214.1400.492.q.60"
    }
  }, [_vm._v("To help eliminate or correct the problem, the Virginia Marine Resources Commission and the Virginia Institute of Marine Science employed watermen who would have worked in the 2008-09 winter dredge season (which was closed by the Virginia Marine Resources Commission) to instead retrieve derelict traps in a structured and environmentally sensitive manner. During the two-year program, watermen found 8,800 crab and eel pots the first year and about as many the second year. Maryland’s Department of Natural Resources conducted a similar program from February 22 to April 1, 2010.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.0.1.box.602.701.1400.384.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.1.0"
    }
  }), _vm._v("In a short time, using grappling hooks dragged across the bottom of the Bay and the West and Rhode rivers off Maryland’s Anne Arundel County coast and other rivers, more than 9,000 crab pots, eel pots, nets, and other debris were collected. It’s not a lot, but it’s a start. The watermen who trawled for these traps were required to log where each pot was recovered, note what condition it was in, and whether there was any fish or crabs in the trap.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.0.2.box.602.1081.1399.112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.2.0"
    }
  }), _vm._v("These derelict traps are not a Chesapeake Bay exclusive. A removal program in Mississippi in 2010 caught 347 traps, which were recycled.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.0.3.box.602.1189.1400.329.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.3.0"
    }
  }), _vm._v("Although Maryland surrounds most of the Bay, Virginia plays an important part in its health. According to the Virginia Institu"), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("te of Marine Science, the state’s seafood industry is one of the oldest industries in the United States and one of the C"), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.0.0"
    }
  }), _vm._v("ommonwealth’s largest, with an annual economic impact of more than $500 million. Blue crabs represent the second largest economic value, after sea"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.0.0.box.402.214.1399.100.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _vm._v("\nscallops and before striped bass, summer flounder, croaker, spot, and clams.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.1.0"
    }
  }), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.19.1.0.box.601.1555.1401.888.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0010.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.0.0.box.402.214.1400.871.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.0.1.box.402.322.1400.221.q.60"
    }
  }, [_vm._v("The Virginia Marine Products Board reports that the United States Department of Commerce says, “Americans consume 16.5 pounds of fish and shellfish per person, with crabs and clams among the ‘top ten’ most popular seafood items.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.0.2.box.402.539.1400.546.q.60"
    }
  }, [_vm._v("About two dozen species of crabs are edible. Although in the U.S., we focus on just a few. The Chesapeake Bay blue crab is the most popular in this area. Stone crabs also are found in the Atlantic Ocean; howeve"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("r, the best-known fishing areas are the Florida Keys and Gulf Coast waters. One claw (sometimes both) is removed and the crab is thrown back in the water to regenerate a new claw, which takes about eighteen months. This is a sustai"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _vm._v("nable way of harvesting claws. Claws can be harvested multiple times from the same crab without killing the crab. Their season is from October 15 through May 15, and if you have them any other time, they’re probably coming from Chile.")]), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.20.1.0.box.399.1096.1403.1350.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0011.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.21.0.0.box.601.226.1399.1266.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0012.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.1.0.box.602.1579.1400.871.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.0.box.602.1579.1400.438.q.60"
    }
  }, [_vm._v("The waters off Alaska’s shores produce seven crab species that are caught commercially. They are the red crab, blue king crab, golden king crab, Tanner crab, snow crab, hair crab, and Dungeness crab. Additionally scarlet king crab, grooved Tanner crab, and Triangle Tanner crab inhabit the waters. They are caught between October and January, with restrictions on the number of days each crabber can bring in a catch. The crabs are frozen while at sea and then shipped around the world for year-round consumption.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.602.2012.1400.372.q.60"
    }
  }, [_vm._v("You can see some of the trials and tribulations involved in harvesting these crabs in the TV series "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Deadliest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Catch ")]), _vm._v("on the Discovery Channel. Just as with the blue crab, Alaska’s crab stock has been depleted over the years. Unlike these boats that are at sea for weeks or months at a time, almost all of the catch from the Bay is caught on day boats that go out early in the morning and return when they’ve reached their limit and run out of hours.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.652.2392.1350.58.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.2.0"
    }
  }), _vm._v("One other crab you’ll hear mentioned along the Eastern Shore"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.22.0.0.box.402.214.1400.696.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _vm._v("\nand the East Coast is the horseshoe crab. Although it looks similar to crustaceans, it belongs to the Chelicerata family and therefore is more closely related to spiders and scorpions of the arthropod family. These crabs live primarily in shallow ocean waters on soft sandy or muddy bottoms. They will, however, come on shore for mating, where the female digs a hole in the sand and lays a few thousand eggs at a time. The eggs take about two weeks to hatch and most succumb to shore birds before they reach the hatching stage. They are commonly used as bait and in fertilizer, and in recent years there has been a decline in number of individuals, as a consequence of coastal habitat destruction and overharvesting along the east coast of North America. There is a moratorium against fishing for horseshoe crabs in New Jersey and Delaware.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.0.0.box.402.214.1400.1087.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.0.1.box.402.918.1400.221.q.60"
    }
  }, [_vm._v("Fossils of horseshoe crabs have been dated from 450 million years ago and have changed very little in the last 250 million years. A hard shell protects the entire body and the long rigid tail is used to flip itself over if it is turned upside down.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.0.2.box.402.1135.1399.166.q.60"
    }
  }, [_vm._v("William Sargent, a consultant for the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("NOVA ")]), _vm._v("science series on PBS"), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _vm._v(" and former director of the National Aquarium, Baltimore, studi"), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  }), _vm._v("ed and wrote about the history and future of the horseshoe crab in "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Crab ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.0.0"
    }
  }), _vm._v("Wars: ")]), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.602.1406.1400.275.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  }), _vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tale ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Horseshoe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Crabs, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bioterrorism, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Human ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Health. ")]), _vm._v("He relates the story of the 300-million-year-old creature that is now involved in a battle between existence and the discovery that the crab’s blood is a part of a reliable test for the deadly and ubiquitous gram-negative bacteria that cause meningitis, typhoid, E. coli, and other diseases.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.22.1.0.box.399.1385.1407.1063.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0013.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.23.0.0.box.605.229.1410.1094.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0014.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.1.0.box.602.1406.1400.1021.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.602.1676.1400.480.q.60"
    }
  }, [_vm._v("Chesapeake Bay blue crab harvests have risen and fallen from the days when the crab was a trash food. Many factors are involved in its survival from how much snow melt there is in any given year to spring rains (when both are heavy, they lower the salinity of the upper Bay thus affecting how far north the crabs will venture). Run off pollution, algae blooms (they shade the underwater grasses, thus stunting the crabs’ growth or killing them outright and adding to the pollution), overharvesting, and other factors all affect the welfare of the crabs.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.602.2164.1400.263.q.60"
    }
  }, [_vm._v("The Bi-State Blue Crab Advisory Committee, the Chesapeake Bay Stock Assessment Committee, the Maryland Department of Natural Resources, the Virginia Marine Resources Committee, and many others gather to try to gauge the health of all things that in one way or another can affect the crabs.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.0.0.box.402.214.1400.2225.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.0.box.402.214.1400.871.q.60"
    }
  }, [_vm._v("Reportedly, crab processors say the restrictions are resulting in an annual sales loss of $13.5 million, with more than 450 processing jobs lost, and perhaps even, the closing of some small and maybe mediumsized processing plants. This is an industry that had fifty-three licensed distributors in 1995. With two-thirds of the processing plants located in Dorchester County (seven small, nine medium size, and all five large plants), on the Eastern Shore, and Dorchester already having the third highest rate of unemployment, this could be a serious economic loss to the county and the state. When you add the indirect income lost by can manufacturers, printers, and bushel barrel suppliers, the multiplier effect becomes enormous. Just as the 2010 oil spill in the Gulf of Mexico had a huge ripple effect on everyone from florists who provided bouquets to delivery drivers and others who supplied and benefited from the related industries. The economic downturn that has been plaguing the country and other economies has resulted in a slightly lower demand for the expensive product.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.1.box.402.1081.1400.600.q.60"
    }
  }, [_vm._v("Another stab at easing the demand on crabbing was a program started in 2009 by the Maryland Department of Natural Resources and the Virginia Marine Resources Commission, which bought back 925 inactive crabbing commercial licenses. There are about 1,800 active crabbers in Maryland. Maryland paid $2,260 for each of 566 licenses while Virginia bought back 359 for varying amounts. These figures were as of January 2010. Although slightly successful, that still leaves a lot of people who seem to be holding on to their license to give or sell to a friend or relative or waiting to see if crabbing becomes more profitable again. Another 2,000 crabbers who didn’t report any catch in 2008 had their permits frozen or restricted.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.2.box.402.1676.1400.167.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.2.0"
    }
  }), _vm._v("The funds, like the monies for the ghost trap program, came from federal disaster funds geared toward the recovery of the Bay. Each state was given $15 million for the various programs.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.3.box.402.1839.1399.161.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.3.0"
    }
  }), _vm._v("Of course, if the crab population were to dwindle to near extinction, whether by overharvesting or just a few years of bad Bay environment, that would have a detrimental effect, too.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.4.box.402.2001.1400.384.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.4.0"
    }
  }), _vm._v("Adding to that is the increase in the importation of crabmeat from overseas (Asia is a large competitor), where the crabs are about a third larger and the labor for picking is considerably less expensive. Notice the packaging when you purchase crabmeat and crab products. For example, the package may say Maryland-style crab cakes (or other products). Look for the oval USA American Blue Crab label to make sure you’re buying American crabmeat.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.0.5.box.452.2381.1350.58.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.5.0"
    }
  }), _vm._v("The packing industry has had more than its share of notoriety in the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.0.0.box.602.214.1400.600.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _vm._v("\npast decade or two. Although there has been some success in a crabpicking machine, most of it still has to be done by humans. Most of the crab pickers at the packing plants on the Eastern Shore are Mexicans who are brought in under the H-2B visa program, which addresses employment needs during peak labor times for amusement parks, ski resorts, and other hospitality and entertainment functions. Maryland senator Barbara Mikulski, chairwoman of the Commerce, Justice, Science (CJS) Appropriations Subcommittee, has been a strong proponent of what she calls “Save Our Small and Seasonal Businesses Act,” which regulates the number of immigrants who may enter each year.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.0.0.box.602.214.1400.2171.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.1.box.602.810.1400.479.q.60"
    }
  }, [_vm._v("The H-2B situation is a serious case of “he said, she said,” and “they said.” On the one hand, crab picking is tough work. The crabs that are picked are small or in new shells so there’s not a lot of meat for the size or the meat can’t be sold to the public. The pay is about $2.00 to $2.50 a pound of crabmeat, and you can get about eight pounds of meat from a bushel of crabs that weighs about fifty pounds. That’s regardless of what size the crabs are. The pickers are paid a bonus for exceeding quotas and are provided with housing and some other benefits.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.2.box.602.1297.1400.546.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.2.0"
    }
  }), _vm._v("It may seem strange that foreigners are being allowed entry into the U.S. when the country is nearing 10 percent unemployment, yet it’s work that most Americans just don’t want to do. The department of labor institutes restrictions on the length of time a worker can be in the country in any one year (usually during the summer months when the crab harvest is at its peak). In order to qualify for the H-2B program, the employer has to file a recruiting report documenting that they tried to recruit local residents, provide information about each person who applied, and explain the lawful job-related reasons for not hiring each U.S. applicant.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.0.3.box.602.1839.1400.546.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.3.0"
    }
  }), _vm._v("However, not all employers treat their employees fairly. A study by the International Human Rights Law Clinic (IHRLC) decried the working and living conditions reported by forty immigrant workers during interviews the organization conducted. Some of the problems occur in Mexico, with local recruiters demanding a recruiting fee from female workers, despite laws that prohibit such payments. Generally, women are hired for picking because they have smaller fingers than men and can pick the meat from the small cavities better than men can. In the United States, rural and isolated living conditions are a problem, and in some cases, workers must rely on their employers for"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.1.0.box.402.1785.1400.275.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0"
    }
  }), _vm._v("\ntransportation into the nearest town. The report also mentioned the lack of modern conveniences afforded the workers, such as a stove and oven. Yet, people who work with these women on a regular basis respond that the women are from rural areas of Mexico and don’t have experience using modern appliances.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.26.0.0.box.399.223.1404.1506.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.402.1785.1400.588.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.402.2056.1400.317.q.60"
    }
  }, [_vm._v("Jack Brooks runs the J.M. Clayton Company, a crab-picking and seafood distribution company founded in 1890 by Capt. John Morgan Clayton, Brooks’s great-grandfather. "), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("The company claims to be the “oldest"), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0"
    }
  }), _vm._v(" working crab processing plant in the world.” Jack’"), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.3.0.0"
    }
  }), _vm._v("s brothers, Bill, Joe, and Clay Brooks, th"), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.4.0.0"
    }
  }), _vm._v("e first of the fifth generation, operate the business.")]), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.5.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.27.0.0.box.599.226.1408.2262.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.1.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.1.0.2"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.0.0.box.402.214.1400.1033.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.0.0.box.402.214.1400.817.q.60"
    }
  }, [_vm._v("During the summer he will have five dozen female workers sitting at long tables picking crabs and packaging the meat into plastic containers that will be weighed, sealed, and refrigerated. More crabs are dumped on the tables as the piles dwindle. Jack says they’ll “package 30,000 pounds of crabs and crabmeat each day during peak season.” To provide customers with off-season crabmeat , Clayton’s imports crabmeat from Indonesia and runs the picking and packing process all year, albeit at a slower pace in the winter. J. Clayton Brooks invented the first automatic crab-picking machine, which was patented in 1973. The Quik Pik takes meat from the shell at a speed of one hundred pounds of crabmeat an hour. However, manual labor is still needed to retrieve the most valuable lump or back fin meat. Jack says it would take twenty-five workers to equal the output of the Quik Pik. Just about every part of the crab is utilized, and stacks of shells are collected to be recycled into various agriculture uses.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.0.1.box.402.1026.1400.221.q.60"
    }
  }, [_vm._v("To see what crab picking is like, watch the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dirty ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Jobs ")]), _vm._v("episode in which Baltimorean Mike Rowe visited J.M. Clayton Company. Jack says Mike was so impressed with this family operation that he returned with his family for a second episode taped at the plant.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-932971f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0017.vue
// module id = 60
// module chunks = 0